import { useEffect, useState } from 'react';
import RegisterWageTypeChart from './RegisterWageTypeChart';
import { getReconSettings, RECON_SETTINGS_EVENT } from './reconSettings';
import { apiFetch } from './apiBase';
import FileUploadField from './FileUploadField';
import HelpTip from './HelpTip';

export default function WageTypeTotals() {
  const [payPeriod, setPayPeriod] = useState(() => getReconSettings().payPeriod);
  const [registerFile, setRegisterFile] = useState(null);
  const [docsInputs, setDocsInputs] = useState(null);

  useEffect(() => {
    apiFetch('/api/docs/inputs')
      .then(setDocsInputs)
      .catch(() => setDocsInputs(null));
  }, []);

  useEffect(() => {
    const onSettings = () => setPayPeriod(getReconSettings().payPeriod);
    window.addEventListener(RECON_SETTINGS_EVENT, onSettings);
    return () => window.removeEventListener(RECON_SETTINGS_EVENT, onSettings);
  }, []);

  return (
    <div className="space-y-6">
      <header className="page-hero">
        <p className="section-title">Payroll register</p>
        <h2 className="mt-1 text-2xl font-bold tracking-tight text-slate-100">Wage type totals</h2>
        <p className="mt-2 max-w-2xl text-sm text-slate-400">
          Upload an ADP payroll register to see total amounts by wage type long text. Uses the register
          Amount column — independent of reconciliation runs.
        </p>
      </header>

      <div className="card-panel p-5">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <label className="block text-sm">
            <span className="font-medium text-slate-300">Pay period</span>
            <input
              value={payPeriod}
              onChange={(e) => setPayPeriod(e.target.value)}
              className="input-field font-mono"
              placeholder="202610"
            />
            <span className="mt-1 block text-xs text-slate-500">
              Default from Settings; override here for this chart only
            </span>
          </label>
          <div className="sm:col-span-2">
            <FileUploadField
              label="ADP payroll register"
              hint="Long-format register export"
              accept=".xlsx,.xls"
              file={registerFile}
              onChange={setRegisterFile}
              savedFile={docsInputs?.payrollRegister}
              helpTerm="register"
              HelpTipComponent={HelpTip}
            />
          </div>
        </div>
      </div>

      <RegisterWageTypeChart registerFile={registerFile} payPeriod={payPeriod} />
    </div>
  );
}
